<template>
	<div>
		<el-form
			:model="dynamicValidateForm"
			ref="dynamicValidateForm"
			label-width="240px"
			class="COrder-dynamic"
		>
			<el-form-item
				prop="appId"
				:label="$t('appName') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseChooseApp'), trigger: 'blur' },
				{ type: 'string', message: $t('payment.pleaseChooseApp'), trigger: ['blur', 'change'] }
			]"
			>
				<el-select filterable v-model="dynamicValidateForm.appId" :placeholder="$t('ticket.select')" style="width:100%;">
					<el-option v-for="(item,index) of appList" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="mtNO" :label="$t('payment.merchantTradeNo') + '：'">
				<el-input :value="dynamicValidateForm.mtNO" :disabled="true"></el-input>
			</el-form-item>
			<el-form-item prop="currency" :label="$t('t.currency') + '：'">
				<el-select filterable v-model="dynamicValidateForm.currency" :placeholder="$t('ticket.select')" style="width:100%;">
					<el-option v-for="(item, index) in currencyList" :key="index" :label="item" :value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				prop="orderAmount"
				:label="$t('tables.listing.recurring_order_amount') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterOrderAmount'), trigger: 'blur' },
				{ type: 'string', message: $t('payment.pleaseEnterCorrectOrderAmount'), trigger: ['blur', 'change'] }
			]"
			>
				<el-input v-model.trim="dynamicValidateForm.orderAmount"></el-input>
			</el-form-item>
			<el-form-item
				prop="email"
				:label="$t('auth.email') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterEmail'), trigger: 'blur' },
				{ type: 'email', message: $t('payment.pleaseEnterCorrectEmail'), trigger: ['blur', 'change'] }
			]"
			>
				<el-input v-model.trim="dynamicValidateForm.email"></el-input>
			</el-form-item>
			<el-form-item
				prop="subject"
				:label="$t('subject') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterSubject'), trigger: 'blur' },
				{ type: 'string', message: $t('payment.pleaseEnterCorrectSubject'), trigger: ['blur', 'change'] }
			]"
			>
				<el-input v-model.trim="dynamicValidateForm.subject"></el-input>
			</el-form-item>
			<el-form-item
				prop="content"
				:label="$t('payment.content') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterContent'), trigger: 'blur' },
				{ type: 'string', message: $t('payment.pleaseEnterCorrectContent'), trigger: ['blur', 'change'] }
			]"
			>
				<el-input v-model.trim="dynamicValidateForm.content"></el-input>
			</el-form-item>
			<el-form-item
				prop="returnUrl"
				:label="$t('payment.returnUrl') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterReturnUrl'), trigger: 'blur' },
				{ type: 'url', message: $t('payment.pleaseEnterCorrectReturnUrl'), trigger: ['blur', 'change'] }
			]"
			>
				<el-input v-model.trim="dynamicValidateForm.returnUrl"></el-input>
			</el-form-item>
			<el-form-item
				prop="expireTime"
				:label="$t('payment.expireTimeMinutes') + '：'"
				:rules="[
				{ required: true, message: $t('payment.pleaseEnterContent'), trigger: 'blur' },
			]"
			>
				<el-input-number type="number" v-model.trim="dynamicValidateForm.expireTime" :min="90"></el-input-number>
			</el-form-item>
			<el-form-item>
				<el-button
					type="primary"
					@click="submitForm('dynamicValidateForm')"
					style="width:100%;height:40px;"
				>{{ $t("basic.button.submit") }}</el-button>
			</el-form-item>
		</el-form>
		<vuestic-modal show.sync="true"
										ref="paymentLink"
										:okText="'modal.confirm2' | translate"
										style="height: 100%;width:60vw;"
										:okClass="'btn btn-primary btn-micro'"
										:cancelClass="'btn btn-secondary btn-micro'"
										:cancelText="'modal.cancel2' | translate"
										alignModal=""
										noButtons
										class="change-email-show"
										@cancel="cancelPaymentLink">
			<div slot="title">{{ $t("payment.paymentLink") }}</div>
			<!-- <div slot="title">{{'modal.refundReason' | translate}}</div> -->
			<div>
				<form>
					<div class="va-row mb-5">
						<div class="flex xs12 md8">
							<div class="form-group with-icon-right mb-0">
								<div class="input-group">
									<textarea id="companyNameInput" name="companyName" :disabled="true" rows="3" v-model="orderUrl"></textarea>
									<i class="bar"></i>
								</div>
							</div>
							<!-- <el-input type="textarea" v-model.trim="orderUrl" :autosize="{ minRows: 3, maxRows: 5 }" :disabled="true" resize="none"></el-input> -->
						</div>
						<div class="flex xs12 md4" style="align-self: end;text-align: right;">
							<button class="btn btn-primary btn-create-order" @click.prevent.stop="copyUrl">
								<div class="btn-with-icon-content">
									<i class="ion-md-copy ion"></i>{{ $t("payment.copyUrl") }}</div>
							</button>
						</div>
					</div>
					<div class="va-row mb-4">
						<div class="flex xs12 md7 text-center">
              <img :src="qrCodeUrl" alt="qrcode" class="order-qr-code">
						</div>
						<div class="flex xs12 md5" style="align-self: end;text-align: right;">
							<button class="btn btn-primary btn-create-order" @click.prevent.stop="copyQRCode">
								<div class="btn-with-icon-content">
									<i class="ion-md-copy ion"></i>{{ $t("payment.copyQrcode") }}</div>
							</button>
						</div>
					</div>
				</form>
			</div>
		</vuestic-modal>
	</div>
</template>
<script>
import { request, guid } from "@/utils/utils.js";
import QRCode from 'qrcode'

export default {
	name: "createOrder",
	data() {
		return {
			dynamicValidateForm: {
				appId: "",
				mtNO: "",
				currency: "BRL",
				orderAmount: "",
				subject: "",
				email: "",
				content: "",
				returnUrl: "",
				expireTime: "90"
			},
			appList: [],
			currencyList: [],
			orderUrl: "",
      qrCodeUrl: ""
		};
	},
	created() {
		this.$set(this.dynamicValidateForm, "mtNO", guid());
	},
	async mounted() {
		await this.initDropdown();
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: "Loading",
						spinner: "el-icon-loading",
						background: "rgba(0, 0, 0, 0.7)",
					});
					let token = localStorage.getItem('Authorization')
					let that = this;
					request({
						method: 'post',
						url: 'api/dashboard/order/generate?&access_token=' + token + '',
						data: {
							'app_id': this.dynamicValidateForm.appId,
							'out_trade_no': this.dynamicValidateForm.mtNO,
							'currency': this.dynamicValidateForm.currency,
							'amount': this.dynamicValidateForm.orderAmount,
							'email': this.dynamicValidateForm.email,
							'subject': this.dynamicValidateForm.subject,
							'content': this.dynamicValidateForm.content,
							'return_url': this.dynamicValidateForm.returnUrl,
							'timeout_express': `${this.dynamicValidateForm.expireTime}m`
						},
						headers: {
							'Content-Type': 'application/json'
						}
					}).then(resp => {
						loading.close();
						let res = resp.data;
						if(res.code === '10000') {
							if(res.msg === 'Success') {
								that.restSubmitData()
								this.$refs.paymentLink.open()
                this.$nextTick (function () {
									this.orderUrl = res.data;
									this.initQrCode(res.data)
                })

							} else {
								this.$message.error('msg: ' + res.msg);
							}
						} else {
							const { msg, sub_msg } = JSON.parse(res.data)
							this.$message.error('msg：'+ res.msg + ', \n' + msg + ', ' + sub_msg);
						}
					})
				} else {
					this.$message.error("The submitted data is incorrect!!!");
					return false;
				}
			});
		},
		initDropdown() {
			let token = localStorage.getItem("Authorization");
			let url = "/api/dashboard/basic/getDropdown?access_token=" + token;
			this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
			request({
				method: "post",
				url,
			}).then((res) => {
				this.searching.close();
				this.appList = res.data.apps;
				this.currencyList = res.data.order_currency;
				this.$set(this.dynamicValidateForm, "appId", this.appList[0].id);
				this.$set(
					this.dynamicValidateForm,
					"currency",
					res.data.order_currency[0]
				);
			}).catch(() => this.searching.close());
		},
		loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
		restSubmitData() {
			this.$set(this.dynamicValidateForm, 'mtNO', guid())
			this.$set(this.dynamicValidateForm, 'orderAmount', '')
			this.$set(this.dynamicValidateForm, 'email', '')
			this.$set(this.dynamicValidateForm, 'subject', '')
			this.$set(this.dynamicValidateForm, 'content', '')
			this.$set(this.dynamicValidateForm, 'returnUrl', '')
		},
		copyUrl() {
			const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', this.orderUrl);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message({
          showClose: true,
          message: 'Copied Successfully',
          type: 'success'
        });
      }
      document.body.removeChild(input);
		},
		copyQRCode() {
			//点击复制二维码
			let myBlob = this.base64ToBlob(this.qrCodeUrl);
			navigator.clipboard.write([new window.ClipboardItem({ [myBlob.type]: myBlob })]);
			this.$message({showClose: true, message: 'Copied Successfully',type: 'success'});
		},
    //生成二维码
    initQrCode(url) {
      QRCode.toDataURL(url)
      .then(imgUrl => {
        this.qrCodeUrl = imgUrl
      })
      .catch(err => {
        console.error(err)
      })
    },
    base64ToBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
		cancelPaymentLink() {
			this.orderUrl = "";
      let container = document.getElementById('qrCode');
      if (container.innerHTML) {
        container.innerHTML = '';
      }
		}
	},
};
</script>
<style lang="scss" scoped>
.COrder-dynamic {
	padding: 50px 20% 150px;
  @media only screen and (max-width: 750px) {
    padding: 50px 60px 50px 20px;
  }
  /deep/ .el-form-item {
    display: flex;
    // .el-form-item__label {
    // }
    .el-form-item__content {
      width: 100%;
      margin-left: 30px!important;
    }
  }
}
.btn-create-order {
	padding: 0.7rem 2rem;
	.btn-with-icon-content {
		display: flex;
		flex-flow: row nowrap;
		justify-content: center;
		align-items: center;
		max-width: 160px;
		i {
			font-size: 24px;
			margin-right: 10px;
		}
	}
}
/deep/ .order-qr-code {
 img {
		margin: 0 auto;
	}
}
</style>
